export const ERROR = 'newService/ERROR'
export const PUBLISH_SERVICE = 'newService/PUBLISH_SERVICE'
export const GET_INTAKE_FORMS = 'newService/GET_INTAKE_FORMS'
export const GET_INTAKE_FORMS_SUCCESS = 'newService/GET_INTAKE_FORMS_SUCCESS'
export const GET_INTAKE_FORMS_ERROR = 'newService/GET_INTAKE_FORMS_ERROR'
export const GET_ADDITIONAL_CONSENT_FORMS = 'newService/GET_ADDITIONAL_CONSENT_FORMS'
export const GET_ADDITIONAL_CONSENT_FORMS_SUCCESS = 'newService/GET_ADDITIONAL_CONSENT_FORMS_SUCCESS'
export const GET_ADDITIONAL_CONSENT_FORMS_ERROR = 'newService/GET_ADDITIONAL_CONSENT_FORMS_ERROR'
export const PUBLISH_SERVICE_SUCCESS = 'newService/PUBLISH_SERVICE_SUCCESS'
export const PUBLISH_SERVICE_ERROR = 'newService/PUBLISH_SERVICE_ERROR'
export const RESET = 'newService/RESET'
export const TOGGLE_CANCEL_PRESSED = 'newService/TOGGLE_CANCEL_PRESSED'

export const syncNewServiceBlacklist = [PUBLISH_SERVICE]
